interface OctroGoldCoinProps {
  size?: number;
  className?: string;
  /** Show embossed star on face (top of stack only in pot) */
  showStar?: boolean;
}

function CoinStar() {
  return (
    <svg className="tp-octro-gold-coin-star" viewBox="0 0 24 24" aria-hidden focusable="false">
      <polygon
        points="12,2.2 14.8,9.1 22.2,9.1 16.2,13.4 18.4,20.8 12,16.6 5.6,20.8 7.8,13.4 1.8,9.1 9.2,9.1"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.35"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/** Single Octro-style gold coin for chip fly / collect animations */
export function OctroGoldCoin({ size = 24, className = '', showStar = true }: OctroGoldCoinProps) {
  return (
    <span
      className={`tp-octro-gold-coin ${className}`.trim()}
      style={{ width: size, height: size }}
      aria-hidden
    >
      {showStar ? <CoinStar /> : null}
    </span>
  );
}

/** Stacked gold coins for the center pot capsule (Octro reference) */
export function OctroGoldCoinStack({ className = '' }: { className?: string }) {
  return (
    <span className={`tp-octro-gold-coin-stack ${className}`.trim()} aria-hidden>
      <OctroGoldCoin className="tp-octro-gold-coin-stack-1" showStar={false} />
      <OctroGoldCoin className="tp-octro-gold-coin-stack-2" showStar={false} />
      <OctroGoldCoin className="tp-octro-gold-coin-stack-3" showStar={false} />
      <OctroGoldCoin className="tp-octro-gold-coin-stack-4" showStar />
    </span>
  );
}

/** Center pot — Octro pill: side stack + leaning face coin (reference art) */
export function OctroPotCoinGraphic({ className = '' }: { className?: string }) {
  return (
    <span className={`tp-octro-pot-coin-graphic ${className}`.trim()} aria-hidden>
      <span className="tp-octro-pot-coin-column">
        <span className="tp-octro-pot-coin-edge tp-octro-pot-coin-edge-1" />
        <span className="tp-octro-pot-coin-edge tp-octro-pot-coin-edge-2" />
        <span className="tp-octro-pot-coin-edge tp-octro-pot-coin-edge-3" />
        <span className="tp-octro-pot-coin-edge tp-octro-pot-coin-edge-4" />
        <span className="tp-octro-pot-coin-edge tp-octro-pot-coin-edge-5" />
        <span className="tp-octro-pot-coin-edge tp-octro-pot-coin-edge-6" />
      </span>
      <span className="tp-octro-pot-coin-face">
        <OctroGoldCoin size={18} showStar />
      </span>
    </span>
  );
}
